import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const ListIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.76921 7.3846C7.76921 8.1493 7.1493 8.76921 6.3846 8.76921C5.61991 8.76921 5 8.1493 5 7.3846C5 6.61991 5.61991 6 6.3846 6C7.1493 6 7.76921 6.61991 7.76921 7.3846Z"
            fill="#000000"
        />
        <path
            d="M7.76921 12.0003C7.76921 12.765 7.1493 13.3849 6.3846 13.3849C5.61991 13.3849 5 12.765 5 12.0003C5 11.2356 5.61991 10.6157 6.3846 10.6157C7.1493 10.6157 7.76921 11.2356 7.76921 12.0003Z"
            fill="#000000"
        />
        <path
            d="M6.3846 18C7.1493 18 7.76921 17.3801 7.76921 16.6154C7.76921 15.8507 7.1493 15.2308 6.3846 15.2308C5.61991 15.2308 5 15.8507 5 16.6154C5 17.3801 5.61991 18 6.3846 18Z"
            fill="#000000"
        />
        <path
            d="M10 6.34778H19.3078C19.5627 6.34778 19.7694 6.55441 19.7694 6.80931V7.96599C19.7694 8.22089 19.5627 8.42753 19.3078 8.42753H10C9.7451 8.42753 9.53847 8.22089 9.53847 7.96599V6.80931C9.53847 6.55441 9.7451 6.34778 10 6.34778Z"
            fill="#000000"
        />
        <path
            d="M19.3078 10.9629H10C9.7451 10.9629 9.53847 11.1695 9.53847 11.4244V12.5754C9.53847 12.8303 9.7451 13.0369 10 13.0369H19.3078C19.5627 13.0369 19.7694 12.8303 19.7694 12.5754V11.4244C19.7694 11.1695 19.5627 10.9629 19.3078 10.9629Z"
            fill="#000000"
        />
        <path
            d="M10 15.5786H19.3078C19.5627 15.5786 19.7694 15.7852 19.7694 16.0401V17.1968C19.7694 17.4517 19.5627 17.6583 19.3078 17.6583H10C9.7451 17.6583 9.53847 17.4517 9.53847 17.1968V16.0401C9.53847 15.7852 9.7451 15.5786 10 15.5786Z"
            fill="#000000"
        />
    </svg>
);